






































import { Component } from 'vue-property-decorator';
import SaascadaVue from '@/components/Shared/SaascadaVue';
import Amount from '@/models/Shared/Amount';

@Component({ name: 'TransactionHistory' })
export default class extends SaascadaVue {

    accounts: Map<Account> = new Map<Account>();
    selectedVersion: number = 0;

    beforeMount() {
        const defaultWalletId = "6f453739-75fa-46b1-957e-d47b99678c43";
        const accountId = "916b1ab5-041f-4ab3-9ec8-2504a30f65d8";
        const wallet = new Wallet();
        wallet.id = defaultWalletId
        wallet.currencyCode = "GBP";
        wallet.isDefault = true;
        wallet.enabled = true;
        wallet.state = State.ACTIVE;
        wallet.balance = "1000.00";
        wallet.availableBalance = "1000.00";
        const accountV1 = new Account();
        accountV1.id = accountId;
        accountV1.defaultCurrencyCode = "GBP";
        accountV1.enabled = true;
        accountV1.state = State.ACTIVE;
        accountV1.version = 1;
        accountV1.defaultWallet = defaultWalletId;
        accountV1.wallets[defaultWalletId] = wallet;

        this.accounts[accountV1.version] = accountV1;

        const accountV2 = JSON.parse(JSON.stringify(accountV1))
        accountV2.wallets[accountV2.defaultWallet].availableBalance = "950.00";
        accountV2.version = 2;

        this.accounts[accountV2.version] = accountV2

        const accountV3 = JSON.parse(JSON.stringify(accountV1))
        accountV3.wallets[accountV3.defaultWallet].balance = "950.00";
        accountV3.wallets[accountV3.defaultWallet].availableBalance = "950.00";
        accountV3.version = 3;

        this.accounts[accountV3.version] = accountV3

        const accountV4 = JSON.parse(JSON.stringify(accountV1))
        accountV4.wallets[accountV4.defaultWallet].balance = "950.00";
        accountV4.wallets[accountV4.defaultWallet].availableBalance = "500.00";
        accountV4.version = 4;

        this.accounts[accountV4.version] = accountV4

        const accountV5 = JSON.parse(JSON.stringify(accountV1))
        accountV5.wallets[accountV5.defaultWallet].balance = "500.00";
        accountV5.wallets[accountV5.defaultWallet].availableBalance = "500.00";
        accountV5.version = 5;

        this.accounts[accountV5.version] = accountV5
    }

    get selectedAccount() {
        if (this.selectedVersion === 0) {
            const defaultWalletId = "6f453739-75fa-46b1-957e-d47b99678c43";
            const accountId = "916b1ab5-041f-4ab3-9ec8-2504a30f65d8";
            const wallet = new Wallet();
            wallet.id = defaultWalletId
            wallet.currencyCode = "GBP";
            wallet.isDefault = true;
            wallet.enabled = true;
            wallet.state = State.ACTIVE;
            wallet.balance = "1000.00";
            wallet.availableBalance = "1000.00";
            const accountV1 = new Account();
            accountV1.id = accountId;
            accountV1.defaultCurrencyCode = "GBP";
            accountV1.enabled = true;
            accountV1.state = State.ACTIVE;
            accountV1.version = 1;
            accountV1.defaultWallet = defaultWalletId;
            accountV1.wallets[defaultWalletId] = wallet;
            return accountV1;
        }
        return this.accounts[this.selectedVersion];
    }

}

class Map<Type> {
    [index: string]: Type;
}

class Account {
    id: string = '';
    defaultCurrencyCode: string = '';
    enabled: boolean;
    state: State = State.ACTIVE;
    version: number = 0;
    defaultWallet: string = '';
    wallets: Map<Wallet> = new Map<Wallet>();
    pendingTransactions?: Map<PaymentAuthorisedEvent> = new Map<PaymentAuthorisedEvent>();
    timezone: string = ''
}

class PaymentAuthorisedEvent {
    accountId: string = '';
    walletId: string = '';
    amount: Amount = new Amount();
    pendingAmount: string = '';
}

class Wallet {
    id: string = '';
    currencyCode: string = '';
    isDefault: boolean;
    enabled: boolean;
    state: State = State.ACTIVE;
    balance: string = '';
    availableBalance: string = '';
    //creditLimit: CreditLimit;
    //channelLimits: ChannelLimit[];
    //velocities: Velocity[];
}

enum State {
    ACTIVE = 'ACTIVE',
    READ_ONLY = 'READ_ONLY',
    SUSPENDED_IN = 'SUSPENDED_IN',
    SUSPENDED_OUT = 'SUSPENDED_OUT',
}

